import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { HousingTypeEnum, HeatingTypeEnum, TarificationIdEnum, CustomerTypeEnum, UtilityTypeEnum, ContractTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import HorizontalFormGroup from "../phases/horizontal-form-group.vue"
import { IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { UtilityTypeFormat, ContractTypeFormat, GenericTypeFormatTranslator } from "../../../../../Scripts/inpulse/FormatUtils";
import { TranslateResult } from "vue-i18n";
import * as moment from "moment-recent";

@Component({
    components: { HorizontalFormGroup },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    }
})

export default class MoveOutContractsSelectionDisplay extends Vue {
    get moveOutName(): string { return this.$store.state.moveOutUser; }

    moveOutCustomerName: string = this.$store.state.contract.Customer.FirstName + " " + this.$store.state.contract.Customer.LastName;
    moveOutCompanyName: string = this.$store.state.contract.Company.CompanyName;

    get contract(): IContractViewModel { return this.$store.state.contract; }

    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;
    HeatingTypeEnum: typeof HeatingTypeEnum = HeatingTypeEnum;
    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;
    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;

    constructor() {
        super();
    }

    join(separator: string, strs: string[]) {
        const arr = [];
        strs.forEach(s => {
            if (s != null && s.length != 0)
                arr.push(s);
        });
        return arr.join(separator);
    }

    formatPostal(postalCode: string, postOffice: string) {
        const str = this.join(", ", [postalCode, postOffice]);
        return str;
    }

    utilityTypeString(type: UtilityTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(UtilityTypeFormat.toString, type, this.$i18n);
    }

    contractTypeString(type: ContractTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(ContractTypeFormat.toString, type, this.$i18n);
    }
}